module.exports = __webpack_public_path__ + "img/file.5d180160.png";